<template>
<div 
        class="aok-kundenberater-button" 
        role="button" 
        tabindex="0" 
        @keydown.enter="openModal" 
        @keydown.space.prevent="openModal"
    >
        <input type="checkbox" id="aokkundenberaterbutton110" class="d-none">
        <label 
            ref="modalTriggerRef"
            for="aokkundenberaterbutton110" 
            class="d-flex flex-column p-3 border rounded w-100"
            data-bs-toggle="modal" 
            data-bs-target="#rdNummerModal2"
            style="cursor: pointer;"
        >
            <div class="d-flex justify-content-between align-items-center">
                <aok_kundenberater_icon></aok_kundenberater_icon>
            </div>
            <h3 class="mt-2">Zum Antrag für AOK-Kundenberater</h3>
        </label>
    </div>

<!-- Modal -->
<div class="modal fade" id="rdNummerModal2" tabindex="-1" aria-labelledby="rdNummerModal2Label">
<div class="modal-dialog modal-xl">
    <div class="modal-content rd-nummer-modal">
    <div class="modal-header border-0">
        <span class="ms-2 me-3">
            <info_icon></info_icon>
        </span>
        <div>
            <b>Eingabe Ihrer RD-Nummer</b>
        </div>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" ref="closeButton"></button>
    </div>
    <div class="modal-body row d-flex align-items-center justify-content-center">
        <div class="col col-12 col-md-6">
            <label for="rdNummerInput" class="form-label">RD-Nummer *</label>
            <div class="input-group mb-3">
                <input 
                    type="text" 
                    class="form-control" 
                    id="rdNummerInput" 
                    v-model="rdnummerInput"
                    maxlength="4"
                    @keypress="onlyNumbers"
                    @keyup.enter="handleSave"
                >
            </div>
            <div v-if="errorMessage" class="text-danger small">{{ errorMessage }}</div>
        </div>
        <div class="col col-12 col-md-6">
            <button 
                type="button" 
                class="btn btn-aok-kundenberater-klein rounded rounded-pill px-4 py-2 d-flex align-items-center justify-content-center w-100"
                @click="handleSave"
                :disabled="isLoading"
            >
                {{ isLoading ? 'Wird geprüft...' : 'Überprüfen und Speichern' }}
                <span class="ms-3 mb-1">
                    <chevron_rechts></chevron_rechts>
                </span>
            </button>
        </div>
    </div>
    </div>
</div>
</div>
</template>

<script setup>
import { ref } from 'vue';
import { useRechnerStore } from '@/stores/rechner';
import { checkRdNummer } from '@/api/RegionaldirektionService';
import info_icon from '@/components/icons/info_icon.vue';
import chevron_rechts from '@/components/icons/chevron_rechts.vue';
import aok_kundenberater_icon from "@/components/icons/aok_kundenberater_icon.vue";

const store = useRechnerStore();
const rdnummerInput = ref('');
const errorMessage = ref('');
const isLoading = ref(false);
const closeButton = ref(null);
const modalTriggerRef = ref(null);

// Modal per Tastatur öffnen (Enter/Space)
const openModal = () => {
    modalTriggerRef.value?.click();
};

// Nur Zahlen erlauben
const onlyNumbers = (event) => {
    if (!/[0-9]/.test(event.key)) {
        event.preventDefault();
    }
};

// RD-Nummer prüfen und speichern
const handleSave = async () => {
    errorMessage.value = '';
    
    if (!rdnummerInput.value || rdnummerInput.value.length !== 4) {
        errorMessage.value = 'Bitte geben Sie eine 4-stellige RD-Nummer ein.';
        return;
    }
    
    isLoading.value = true;
    
    try {
        const result = await checkRdNummer(rdnummerInput.value);
        
        if (result.success) {
            // ✅ Erfolg: RD-Nummer im Store speichern
            store.aok = result.rdnummer;
            store.aokName = result.aokName;
            
            // Modal schließen
            closeButton.value?.click();
            
            // Input zurücksetzen für nächste Öffnung
            rdnummerInput.value = '';
        } else {
            // ❌ Fehler: Store zurücksetzen und Fehlermeldung anzeigen
            store.aok = 0;
            store.aokName = '';
            errorMessage.value = 'Die RD-Nummer ist im System nicht vorhanden. Bitte überprüfen Sie die Eingabe.';
        }
    } catch (error) {
        // ❌ Netzwerkfehler: Store zurücksetzen
        store.aok = 0;
        store.aokName = '';
        errorMessage.value = 'Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.';
    } finally {
        isLoading.value = false;
    }
};
</script>